var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickedOutside,
          expression: "clickedOutside",
        },
      ],
      ref: "emdBasicFilter",
      staticClass: "emd-filter-dash__input",
      class: { _focus: _vm.shortcutOpenned },
    },
    [
      _c("emd-input-tag", {
        ref: "inputTag",
        attrs: {
          "data-testid": "search-order",
          listType: "complex",
          list: _vm.shortcuts,
          validKeys: _vm.validKeys,
          focus: _vm.inputTagFocused,
          disabled: _vm.loadingList,
          input: _vm.input,
        },
        on: {
          onClick: _vm.openShortcut,
          inputChanged: _vm.handleInputChange,
          onSubmit: _vm.handleSubmit,
          listUpdated: _vm.updateShortcuts,
          onBlur: _vm.handleBlur,
        },
      }),
      _c("div", { staticClass: "emd-filter-dash__options" }, [
        _c("table", [
          _c("tbody", [
            _c(
              "tr",
              {
                class: { _disabled: _vm.shortcutAlreadySelected("any_ids") },
                on: {
                  click: function ($event) {
                    return _vm.selectShortcut("any_ids", "i")
                  },
                },
              },
              [
                _c(
                  "td",
                  {
                    staticClass: "emd-text _color_default _type_caption",
                    attrs: { "data-testid": "search-order-by-id" },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.computedShortcut.identifier)),
                    ]),
                  ]
                ),
                _c("td", { staticClass: "emd-text _color_default" }, [
                  _vm._v(" " + _vm._s(_vm.computedShortcut.idText)),
                  _c("br"),
                  _c("code", [_vm._v(_vm._s(_vm.computedShortcut.idCode))]),
                ]),
              ]
            ),
            _vm.showShortcutCustomer
              ? _c(
                  "tr",
                  {
                    class: {
                      _disabled: _vm.shortcutAlreadySelected("customers"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectShortcut("customers", "c")
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "emd-text _color_default _type_caption",
                        attrs: { "data-testid": "search-order-by-customer" },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.computedShortcut.customer)),
                        ]),
                      ]
                    ),
                    _c("td", { staticClass: "emd-text _color_default" }, [
                      _vm._v(" " + _vm._s(_vm.computedShortcut.customerText)),
                      _c("br"),
                      _c("code", [
                        _vm._v(_vm._s(_vm.computedShortcut.customerCode)),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _c("hr", { staticClass: "emd-divider" }),
        _c("div", { staticClass: "emd-filter-dash__options__footer" }, [
          _c("p", { staticClass: "emd-text _color_subtle" }, [
            _vm._v(" " + _vm._s(_vm.computedShortcut.text) + " "),
          ]),
          _c("p", { staticClass: "emd-text _color_subtle" }, [
            _vm._v(" " + _vm._s(_vm.computedShortcut.example) + " "),
          ]),
        ]),
      ]),
      _vm.shortcuts.length
        ? _c(
            "a",
            {
              staticClass:
                "emd-action-button _square _size_small _lvl_2 eu-ml_1 _color_danger",
              class: { _disabled: _vm.loadingList },
              attrs: { href: "javascript:void(0)", alt: _vm.$t("clear") },
              on: { click: _vm.clearBasicFilter },
            },
            [
              _c("i", {
                staticClass: "uil uil-times emd-action-button__icon",
                attrs: { "data-testid": "orders-simple-filter-remove-btn" },
              }),
            ]
          )
        : _vm._e(),
      !_vm.advancedIsOpenned
        ? _c(
            "a",
            {
              staticClass: "emd-btn _color_primary eu-no-shadow",
              class: { _disabled: _vm.loadingList },
              attrs: {
                href: "javascript:void(0)",
                alt: _vm.$t("search"),
                disabled: _vm.loadingList,
              },
              on: { click: _vm.search },
            },
            [
              _c("i", {
                staticClass: "uil uil-search",
                attrs: { "data-testid": "orders-search-simple-btn" },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }